import { Table } from 'react-dsgov';
import { BrButton, BrLoading } from '@govbr-ds/react-components';
import { useNavigate } from 'react-router-dom';
import { ExercicioSelect } from '../../exercicioSelect/exercicioSelect';
import styles from './naoIniciadaTable.module.scss';
import { useEffect, useState } from 'react';

interface IHeader {
  field: string;
  label: string;
}

interface IProps {
  months: number[];
  isLoading: boolean;
  page: 'primeiro-adquirente' | 'hasta-publica';
  ano: string;
}

export const NaoIniciadaTable = ({ months, isLoading, page, ano }: IProps) => {
  const navigate = useNavigate();

  const userNomeRazaoSocial = sessionStorage.getItem('userNomeRazaoSocial');
  const [noMesError, setNoMesError] = useState(false);

  const onIniciarClick = () => {
    if (sessionStorage.getItem('mesDeclaracao') === '-1') setNoMesError(true);
    else {
      setNoMesError(false);
      navigate(`/${page}/edit?id=${crypto.randomUUID()}`);
    }
  };

  useEffect(() => {
    setNoMesError(false);
  }, [months, ano]);

  const headers: IHeader[] = [
    { field: 'declarante', label: 'Declarante' },
    { field: 'exercicio', label: 'Exercício' },
    { field: 'acao-iniciar', label: 'Ação' },
  ];

  return (
    <div className={`${styles.customTable}`}>
      <Table showTopBar={false} headers={headers} showPagination={false}>
        <tbody>
          {!isLoading && (
            <tr>
              <td className={styles.statusColumn}>{userNomeRazaoSocial}</td>
              <td className={styles.statusColumn}>
                <div className={styles.selectContainer}>
                  <ExercicioSelect dates={months} ano={ano} />
                  {noMesError && <span className={styles.errorText}>Selecione um mês</span>}
                </div>
              </td>
              <td className={styles.actionColumn}>
                {months.length > 0 ? (
                  <BrButton onClick={() => onIniciarClick()}>
                    <i className={`fas fa-edit fa-md ${styles.columnIcon}`} /> Iniciar
                  </BrButton>
                ) : (
                  '-'
                )}
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      {isLoading && (
        <div className={styles.tableLoading}>
          <BrLoading large label='Carregando...' />
        </div>
      )}
    </div>
  );
};
